'use client';

import { type IDefaultFormBuilderProps } from '@/components/Form/Fields/types';
import UploadField from '@/components/UploadField/UploadField';
import { RichText } from '@/components/richText/RichText';
import { hasContent } from '@/helper/RichText';
import type {
  FileAmountStoryblok,
  FileTypesStoryblok,
  FormFileUploadStoryblok,
  MaxFileSizeStoryblok,
  RequiredStoryblok,
  RichtextStoryblok,
} from '@/types/component-types-sb';
import { type FC } from 'react';

interface IFileUploadField extends Omit<FormFileUploadStoryblok, 'label'>, Omit<IDefaultFormBuilderProps, 'label'> {
  label?: RichtextStoryblok | string;
  validators?: (RequiredStoryblok | FileTypesStoryblok | MaxFileSizeStoryblok | FileAmountStoryblok)[];
}

const FileUploadField: FC<IFileUploadField> = ({
  field,
  id,
  label,
  headline,
  errorMessage,
  required,
  validators,
  infoText,
  isInvalid,
}) => {
  const allowedTypes =
    validators
      ?.find((validator) => validator.component === 'FileTypes')
      ?.allowedTypes?.map((type: unknown) => `${type}`) ?? [];

  const maxFileSize = validators?.find((validator) => validator.component === 'MaxFileSize')?.maxFileSize;
  const maxFiles = validators?.find((validator) => validator.component === 'FileAmount')?.amount;

  return (
    <UploadField
      {...field}
      id={id}
      label={label}
      acceptedFileTypes={allowedTypes}
      maxFiles
      headline={headline}
      required={required}
      infoText={hasContent(infoText) && <RichText text={infoText} />}
      error={isInvalid}
      externalErrorMessage={errorMessage}
      {...(maxFileSize && { maxFileSize })}
      {...(maxFiles && { maxFiles })}
    />
  );
};

export default FileUploadField;
